import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../../services';

declare var jQuery:any;

@Component({
    selector: 'alert',
    template: require('./alert.component.html')
})

export class AlertComponent implements OnInit {
    message: any;

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.alertService.getMessage().subscribe(
        message => {
            this.message = message;
            jQuery("#alert_message").focus();
        });
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/components/common/alert/alert.component.ts